const Clock = ({
  height = '20px',
  width = '20px',
  fill = '#2A3135',
  stroke = '#2A3135',
}) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <g fill={fill} fillRule="nonzero" stroke={stroke} strokeWidth=".4">
      <path d="M13.207 11.59l-2.51-1.883V5.873a.697.697 0 10-1.394 0v4.183c0 .22.103.426.279.558l2.788 2.09a.693.693 0 00.976-.14.696.696 0 00-.14-.975z" />
      <path d="M10 1c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9zm0 16.606c-4.193 0-7.606-3.413-7.606-7.606S5.807 2.394 10 2.394c4.194 0 7.606 3.413 7.606 7.606S14.193 17.606 10 17.606z" />
    </g>
  </svg>
);

export default Clock;
